import styled from 'styled-components'

export const PlanDetailWrapper = styled.div`
  padding-top: 63px;
`
